'use client';

import { useState, useEffect } from 'react';
import AnchorNavigation from '@/components/common/AnchorNavigation';
import HeroSection from './HeroSection';
import TrustIndicatorBar from '@/components/common/TrustIndicatorBar';
import ProblemSection from './ProblemSection';
import ProcessSection from './ProcessSection';
import GoldPriceCalculator from '@/components/common/GoldPriceCalculator';
import SecuritySection from './SecuritySection';
import CertificationSection from './CertificationSection';
import TestimonialSection from './TestimonialSection';
import FAQSection from './FAQSection';
import GuaranteeSection from './GuaranteeSection';
import ContactCTASystem from '@/components/common/ContactCTASystem';
import FooterSection from './FooterSection';

const LandingPageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState<boolean>(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const scrollToCalculator = () => {
    const element = document.getElementById('priskalkulator');
    if (element) {
      const offsetTop = element?.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      const offsetTop = element?.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  if (!isHydrated) {
    return (
      <>
        <AnchorNavigation />
        <HeroSection 
          onCalculatorClick={scrollToCalculator}
          onGetQuoteClick={scrollToCalculator}
        />
        <GoldPriceCalculator />
        <TrustIndicatorBar />
        <ProblemSection />
        <ProcessSection />
        <SecuritySection />
        <CertificationSection />
        <TestimonialSection />
        <FAQSection />
        <GuaranteeSection />
        <ContactCTASystem variant="inline" showCalculatorLink={true} />
        <FooterSection />
      </>
    );
  }

  return (
    <>
      <AnchorNavigation />
      <HeroSection 
        onCalculatorClick={scrollToCalculator}
        onGetQuoteClick={scrollToCalculator}
      />
      <GoldPriceCalculator />
      <TrustIndicatorBar />
      <ProblemSection />
      <ProcessSection />
      <SecuritySection />
      <CertificationSection />
      <TestimonialSection />
      <FAQSection />
      <GuaranteeSection />
      <ContactCTASystem variant="inline" showCalculatorLink={true} />
      <ContactCTASystem variant="sticky" showCalculatorLink={false} />
      <FooterSection />
    </>
  );
};

export default LandingPageInteractive;